import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  ogUrl?: string;
  canonical?: string;
}

export const SEO = ({
  title = 'Preswald - AI Data App Builder',
  description = 'Build powerful data applications with AI',
  keywords = 'AI, data applications, app builder, web development',
  ogImage = '/og-image.jpg',
  ogUrl = 'https://preswald.com',
  canonical,
}: SEOProps) => {
  const fullTitle = title === 'Preswald - AI Data App Builder' ? title : `${title} | Preswald`;
  const canonicalUrl = canonical || ogUrl;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={ogUrl} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}; 